import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-overlay"
}
const _hoisted_2 = { class: "app-overlay__content" }
const _hoisted_3 = {
  key: 0,
  class: "app-overlay__text"
}

import { useOverlay } from '@/composables/useOverlay'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppOverlay',
  setup(__props) {

const { overlayVisible, overlayText } = useOverlay()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "app-overlay" }, {
    default: _withCtx(() => [
      (_unref(overlayVisible))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("div", {
                class: "spinner-border text-primary app-overlay__spinner",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ], -1)),
              (_unref(overlayText))
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(overlayText)), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})